<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            color="primary"
            icon="mdi-bank-transfer"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                DTS Deposits for {{ sitedetails.idnum }}
              </div>
            </template>
            <v-data-table
              :headers="headers"
              :items="getDeposits"
              :search="search"
              sort-by="DTSUniqueId"
              sort-desc
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Deposits</v-toolbar-title>

                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="warning"
                        dark
                        class="mb-2"
                        to="/Depositactions"
                      >
                        Return
                      </v-btn><v-btn
                        color="primary"
                        dark
                        class="mb-2 mr-4"
                        v-on="on"
                      >
                        New Deposit
                      </v-btn>
                    </template>
                    <template v-slot:item.timestamp="{ item }">
                      {{ format_time(item.timestamp) }}
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-form v-model="valid">
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-text-field
                                  v-model="editedItem.BagNumber"
                                  :rules="bag_rule"
                                  outlined
                                  label="DTS Bag Number"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-menu
                                  ref="menu1"
                                  v-model="menu1"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="editedItem.SalesDate"
                                      label="Sales Date"
                                      persistent-hint
                                      prepend-icon="mdi-calendar"
                                      v-bind="attrs"
                                      v-on="on"
                                    />
                                  </template>
                                  <v-date-picker
                                    v-model="editedItem.SalesDate"
                                    no-title
                                    @input="menu1 = false"
                                  />
                                </v-menu>
                              </v-col>
                              <v-col
                                cols="6"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.Notes1"
                                  outlined
                                  :rules="numeric_only"
                                  label="Ones"
                                />
                              </v-col>
                              <v-col
                                cols="6"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.Notes2"
                                  outlined
                                  :rules="numeric_only"
                                  label="Twos"
                                />
                              </v-col>
                              <v-col
                                cols="6"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.Notes5"
                                  outlined
                                  :rules="numeric_only"
                                  label="Fives"
                                />
                              </v-col>
                              <v-col
                                cols="6"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.Notes10"
                                  outlined
                                  :rules="numeric_only"
                                  label="Tens"
                                />
                              </v-col>
                              <v-col
                                cols="6"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.Notes20"
                                  outlined
                                  :rules="numeric_only"
                                  label="Twenties"
                                />
                              </v-col>
                              <v-col
                                cols="6"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.Notes50"
                                  outlined
                                  :rules="numeric_only"
                                  label="Fifties"
                                />
                              </v-col>
                              <v-col
                                cols="6"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.Notes100"
                                  outlined
                                  :rules="numeric_only"
                                  label="Hundreds"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-text-field
                                  v-model="totalcurrency"
                                  readonly
                                  outlined
                                  label="Total Currency"
                                />
                              </v-col>
                              <v-col
                                cols="6"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.Coin100"
                                  outlined
                                  :rules="numeric_only"
                                  label="Coin 100"
                                />
                              </v-col>
                              <v-col
                                cols="6"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.Coin200"
                                  outlined
                                  :rules="numeric_only"
                                  label="Coin 200"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-text-field
                                  v-model="totalcoin"
                                  outlined
                                  label="coin total"
                                />
                              </v-col>
                              <v-col
                                cols="6"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.CheckCount"
                                  outlined
                                  :rules="numeric_only"
                                  label="Check Count"
                                />
                              </v-col>
                              <v-col
                                cols="6"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.CheckAmount"
                                  outlined
                                  :rules="numeric_only"
                                  label="Total Checks"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-text-field
                                  v-model="totaldeposit"
                                  outlined
                                  label="Total Deposit"
                                />
                              </v-col>
                              <v-card-title>
                                <span class="body light">Deposit will be active once saved</span>
                              </v-card-title>
                            </v-row>
                          </v-form>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="warning"
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="primary"
                          :disabled="!formIsValid"
                          @click="save"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.Label="{ item }">
                <v-dialog
                  v-if="item.Image"
                  v-model="dialogtest"
                  max-width="500px"
                >
                  <v-card>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                          >
                            <v-img
                              :src="image_render(popImage)"
                              contain
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="closeimage"
                      >
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-icon
                  v-if="item.Image"
                  color="primary"
                  size="20"
                  @click="imageItem(item)"
                >
                  mdi-barcode
                </v-icon>
              </template>
              <template v-slot:no-data>
                Sorry, No deposit info {{ sitedetails.idnum }}
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  const axios = require('axios')
  var numeral = require('numeral')

  export default {
    name: 'Depositusersbysite',
    props: ['id'],
    data: () => ({
      dialog: false,
      dialogimage: false,
      search: '',
      popImage: '',
      dialogtest: false,
      valid: false,
      menu1: false,
      salesdate_rule: [
        v => !!v || 'Sales Date is required',
      ],
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 10 || 'Name must be less than 10 characters',
      ],
      numeric_only: [
        v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
      ],
      bag_rule: [
        v => !!v || 'Bag number is required',
        v => v.length === 9 || 'Bag ID must be 9 digits',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
      ],
      sitedetails: '',
      snackbar: false,
      timeout: 5000,
      alertmessage: '',
      headers: [
        { text: 'Deposit Date', align: 'center', value: 'DepositDate', sortable: true },
        { text: 'Deposit ID', align: 'center', value: 'DepositId', sortable: true },
        { text: 'Transaction', align: 'center', value: 'TransactionId', sortable: true },
        { text: 'DTS ID', align: 'center', value: 'DTSUniqueId', sortable: true },
        { text: 'Label', align: 'center', value: 'Label', sortable: false },
        { text: 'Bag Number', align: 'center', value: 'BagNumber', sortable: true },
        { text: 'Amount', align: 'center', value: 'DepositAmount', sortable: true },
      ],
      depositusers: [],
      editedIndex: -1,
      editedItem: {
        CustomerIdentifier: '',
        LocationIdentifier: '',
        // or LocationNumber but NOT BOTH
        DepositDate: '',
        SalesDate: '',
        BagNumber: '',
        Notes1: 0,
        Notes2: 0,
        Notes5: 0,
        Notes10: 0,
        Notes20: 0,
        Notes50: 0,
        Notes100: 0,
        CurrencyAmount: 0,
        Coin100: 0,
        Coin200: 0,
        CoinAmount: 0,
        CheckCount: 0,
        CheckAmount: 0,
        DepositAmount: 0,
        ResponseType: 'JSON'
      },
      defaultItem: {
        CustomerIdentifier: '',
        LocationIdentifier: '',
        // or LocationNumber but NOT BOTH
        DepositDate: '',
        SalesDate: '',
        BagNumber: '',
        Notes1: 0,
        Notes2: 0,
        Notes5: 0,
        Notes10: 0,
        Notes20: 0,
        Notes50: 0,
        Notes100: 0,
        CurrencyAmount: 0,
        Coin100: 0,
        Coin200: 0,
        CoinAmount: 0,
        CheckCount: 0,
        CheckAmount: 0,
        DepositAmount: 0,
        ResponseType: 'JSON'
      },
    }),

    computed: {
      formIsValid () {
        return this.editedItem.email !== '' &&
          this.editedItem.accesscode !== '' &&
          this.editedItem.username !== ''
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New DTS Deposit' : 'Edit Deposit'
      },
      getalerts () {
        this.alerts = this.$store.getters.alerts
        return this.alerts
      },
      getDeposits () {
        let deposits = []
        deposits = this.$store.getters.getDTSDeposits
        return deposits
      },
      getcompleted () {
        return this.$store.getters.loadedCompletedDeposits
      },
      totalcurrency () {
        let total = 0

        total = parseInt(this.editedItem.Notes1) + parseInt(this.editedItem.Notes2) + parseInt(this.editedItem.Notes5) + parseInt(this.editedItem.Notes10) + parseInt(this.editedItem.Notes20) + parseInt(this.editedItem.Notes50) + parseInt(this.editedItem.Notes100)
        if (!isNaN(total)) {
          this.editedItem.CurrencyAmount = total
          return total
        }
        return 'Please ensure all entries are valid or 0'
      },
      totaldeposit () {
        let total = 0
        total = parseInt(this.editedItem.CoinAmount) + parseInt(this.editedItem.CurrencyAmount) + parseInt(this.editedItem.CheckAmount)
        if (!isNaN(total)) {
          this.editedItem.DepositAmount = total
          return total
        }
        return 'Please ensure all entries are valid or 0'
      },
      totalcoin () {
        let total = 0
        total = parseInt(this.editedItem.Coin100) + parseInt(this.editedItem.Coin200)
        if (!isNaN(total)) {
          this.editedItem.CoinAmount = total
          return total
        }
        return 'Please ensure all entries are valid or 0'
      },
      totalchecks () {
        return 0
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogtest (val) {
        val || this.closeimage()
      },
    },

    created () {
      this.id = this.$route.params.id
      this.getsitemap(this.id)
      this.$log.debug('LOADING THIS ID ', this.id)
      this.$store.dispatch('initrealtimeDTSDeposits', this.id)

      this.initialize()
    },
    beforeDestroy () {
      this.$store.dispatch('stoprealtimeDTSDeposits', this.id)
    },
    methods: {
      initialize () {
        this.alerts = this.$store.getters.alerts
        this.depositusers = this.$store.getters.loadedPendingDeposits
      },
      closeimage () {
        this.dialogtest = false
        setTimeout(() => {
          this.popImage = Object.assign({}, '')
        }, 300)
      },
      show_image () {
        this.dialogimage = true
      },
      image_render (value) {
        let prefix = 'data:image/png;base64,'
        return prefix + value
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('MM-DD-YY, HH:mm:ss')
      },
      getsitemap (machineid) {
        this.$log.debug('sitemap')
        // this.$store.dispatch("loadPendingDeposits", machineid)
        this.$store.dispatch('loadDTSDeposits', machineid)
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.siteunitsprofile) {
            if (value.siteunitsprofile[0].crypto_idnum === machineid) {
              this.$log.debug(value)
              this.sitedetails = this.$store.getters.loadedSites.find(location => value.idnum === location.idnum)
            }
          }
        }
      },
      editItem (item) {
        this.editedIndex = this.depositusers.indexOf(item)
        this.$log.debug('edited index is ', this.editedIndex, 'edited item was ', item, 'alerts array is ', this.depositusers)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      imageItem (item) {
        // this.$log.debug('edited index is ', this.editedIndex, 'edited item was ', item, 'alerts array is ', this.depositusers)
        this.popImage = item.Image
        this.dialogtest = true
      },
      deleteItem (item) {
        const index = this.depositusers.indexOf(item)
        this.$log.debug('site info is ', item)
        if (confirm('Are you sure you want to delete this item?') && this.depositusers.splice(index, 1)) {
          this.$log.debug('site info is ', item.key)
          let rec = {
            key: item.key,
            siteid: this.id
          }
          this.$store.dispatch('removePendingDeposit', rec)
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        this.$log.debug('EDITED INDEX WAS ', this.editedIndex)
        const deposit = {
          CustomerIdentifier: 'SSAlpha',
          LocationIdentifier: '200',
          LocationNumber: null,
          // or LocationNumber but NOT BOTH
          DepositDate: moment(Date.now()).format('YYYY-MM-DD'),
          SalesDate: this.editedItem.SalesDate,
          BagNumber: this.editedItem.BagNumber,
          Notes1: this.editedItem.Notes1,
          Notes2: this.editedItem.Notes2,
          Notes5: this.editedItem.Notes5,
          Notes10: this.editedItem.Notes10,
          Notes20: this.editedItem.Notes20,
          Notes50: this.editedItem.Notes50,
          Notes100: this.editedItem.Notes100,
          CurrencyAmount: this.editedItem.CurrencyAmount,
          Coin001: this.editedItem.Coin001,
          Coin005: this.editedItem.Coin005,
          Coin010: this.editedItem.Coin010,
          Coin025: this.editedItem.Coin025,
          Coin050: this.editedItem.Coin050,
          Coin100: this.editedItem.Coin100,
          Coin200: this.editedItem.Coin200,
          CoinAmount: this.editedItem.CoinAmount,
          CheckCount: this.editedItem.CheckCount,
          CheckAmount: this.editedItem.CheckAmount,
          DepositAmount: this.editedItem.DepositAmount,
          ResponseType: 'JSON-IMAGE'
        }
        let payload = {
          depositrec: deposit,
          creditproviderId: this.sitedetails.creditproviderId,
          creditproviderLocationID: this.sitedetails.creditproviderLocationID,
          creditproviderapikey: this.sitedetails.creditproviderapikey,
          siteid: this.id
        }
        this.$store.dispatch('createDTSDeposit', payload)
        this.editedItem = this.defaultItem
        // this.depositusers = this.$store.getters.depositusers
        this.close()
      },
    },
  }
</script>
